import {
  StopTypes,
  StopProgress,
  StopServices,
  StopExceptions,
  DriverRequests,
} from './FilterTypes';
import { FilterTypes } from '../models/stop';
import {
  ALL,
  DELIVERIES,
  PREMIUM,
  PICKUP,
  SWAPIT,
  TIMED,
  COLLECTIONS,
  BULK,
  PERISHABLE,
  SMALLS,
  VIP,
  NON_CADS,
  NOT_LOADED,
  CADS,
  LOADED,
  TEN_THIRTY,
  TWELVE,
  PRECISE,
  AFTERNOON,
  EVENING,
  SATURDAY,
  SUNDAY,
  NONE,
  POSTCODE,
  DUTY,
  SERVICE,
  OPPORTUNITY,
  RANGE,
  LEGAL_DUTY,
  REQUEST,
} from '../constants/strings';
import { pickupKindTypes, pickupKindTypesLabels } from './stopTypes';

const StopTypeFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: DELIVERIES,
    value: StopTypes.delivery,
  },
  {
    label: PREMIUM,
    value: StopTypes.premium,
  },
  {
    label: PICKUP,
    value: StopTypes.pickup,
  },
  {
    label: SWAPIT,
    value: StopTypes.swapit,
  },
  {
    label: TIMED,
    value: StopTypes.timed,
  },
  {
    label: COLLECTIONS,
    value: StopTypes.collections,
  },
  {
    label: BULK,
    value: StopTypes.bulk,
  },
  {
    label: PERISHABLE,
    value: StopTypes.perishable,
  },
  {
    label: SMALLS,
    value: StopTypes.smalls,
  },
  {
    label: VIP,
    value: StopTypes.vip,
  },
];

const StopPickupKindFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: 'Shop',
    value: pickupKindTypes.shop,
  },
  {
    label: 'Locker',
    value: pickupKindTypes.locker,
  },
];

const StopProgressFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: NON_CADS,
    value: StopProgress.nonCAD,
  },
  {
    label: NOT_LOADED,
    value: StopProgress.nonLoaded,
  },
  {
    label: CADS,
    value: StopProgress.CAD,
  },
  {
    label: LOADED,
    value: StopProgress.loaded,
  },
];

const ServicesFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: TEN_THIRTY,
    value: StopServices.tenThirty,
  },
  {
    label: TWELVE,
    value: StopServices.twelve,
  },
  {
    label: PRECISE,
    value: StopServices.precise,
  },
  {
    label: AFTERNOON,
    value: StopServices.afternoon,
  },
  {
    label: EVENING,
    value: StopServices.evening,
  },
  {
    label: SATURDAY,
    value: StopServices.saturday,
  },
  {
    label: SUNDAY,
    value: StopServices.sunday,
  },
];

const ExceptionsFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: NONE,
    value: StopExceptions.none,
  },
  {
    label: POSTCODE,
    value: StopExceptions.postcode,
  },
  {
    label: DUTY,
    value: StopExceptions.duty,
  },
  {
    label: SERVICE,
    value: StopExceptions.service,
  },
  {
    label: OPPORTUNITY,
    value: StopExceptions.opportunity,
  },
  {
    label: RANGE,
    value: StopExceptions.range,
  },
  {
    label: LEGAL_DUTY,
    value: StopExceptions.legalDuty,
  },
];

const RequestsFilters = [
  {
    label: ALL,
    value: '',
  },
  {
    label: REQUEST,
    value: DriverRequests.Requests,
  },
];

export default [
  {
    title: 'Stop Type',
    field: FilterTypes.stopType,
    values: StopTypeFilters,
  },
  {
    title: 'Stop Progress',
    field: FilterTypes.stopProgress,
    values: StopProgressFilters,
  },
  {
    title: 'Service Filters',
    field: FilterTypes.service,
    values: ServicesFilters,
  },
  {
    title: 'Exception Filters',
    field: FilterTypes.exception,
    values: ExceptionsFilters,
  },
  {
    title: 'Request Filters',
    field: FilterTypes.request,
    values: RequestsFilters,
  },
  {
    title: 'Pickup Kind',
    field: FilterTypes.pickupKind,
    values: StopPickupKindFilters,
  },
];
